import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faGithub } from '@fortawesome/free-brands-svg-icons'
import "./Projects.css";


class Projects extends Component {
    state = {
        expandedCard: null
    }

    toggleDescription = (index: number) => {
        this.setState({ expandedCard: this.state.expandedCard === index ? null : index });
    }
    render() {
        const cardData = [
            {
                title: 'Card 1',
                text: 'Winter WonderMap',
                image: "media/wintermap.mp4",
                thumbnail: "media/wondermap.png",
                description: "Interactive festive events map for London. Leveraging React, Node.js, Express.js, Leaflet.js, and SQL, our platform offers users an immersive experience. Users can effortlessly navigate the map of London, where markers representing various festive events appear based on the categories they select. Our platform facilitates event booking directly through the application, ensuring users receive email confirmations for successful bookings. Users can seamlessly manage their schedules by adding booked events to their calendars, ensuring easy access and organisation. With a focus on user-centric design and functionality, our collaborative effort delivers a comprehensive solution for discovering, booking, and managing holiday events in London.",
                codeLink: "https://github.com/charlotteswebdev/WinterWonderMap"
            },         
            {
                title: 'Card 2',
                text: 'PickFlix',
                image: 'media/PickFlix.mp4',
                thumbnail: "media/pickflix.png",
                description: "Movie and TV series recommender, custom styled using vanilla JavaScript. Website welcomes users, allowing them to input their preferred genre. Based on their selection, the application generates a movie or TV series recommendation. The website provides direct links to streaming platforms where the recommended content can be viewed. Users also have the option to restart the generator for a new recommendation. The website's design and layout are customized to enhance the user experience, creating an engaging and interactive platform for discovering new entertainment options.",
                codeLink: "https://github.com/charlotteswebdev/PickFlix",
                demoLink: "https://pickflix-app.netlify.app/"

            },
            {
                title: 'Card 3',
                text: 'The Portal',
                image: 'media/portal.mp4',
                thumbnail: "media/welcome_page_portal.png",
                description: "User authentication system built using React and Redux, featuring login and logout functionalities. The user's name is securely stored within a global Redux store, enabling personalised welcome messages upon login. The system includes input validation and an error screen is implemented to gracefully handle any authentication errors.",
                codeLink: "https://github.com/charlotteswebdev/ThePortal",
                demoLink: "https://theportal-login.netlify.app/"
            },
            {
                title: 'Card 4',
                text: 'Pawsitive Adoptions',
                image: 'media/PawsitiveAdoptions.mp4',
                thumbnail: "media/dogs.jpg",
                description: "API server for a dog adoption service developed using Python with Flask and SQL. Dog information is stored within a MySQL database, enabling users to fetch details based on their preferences. The application displays the availability of dogs in the console, providing users with real-time information.  Users have the option to sign up for a mailing list to receive updates on dog availability and adoption events. Additionally, the application offers an overview of shelter information, including location and the number of dogs available for adoption. Group project with the 4CodeGirls Team - Kemi Mokwenyei, Sophia AhmedAlie, Lauren Gray, Jessica Upson and Ana Catarina Basilio.",
                codeLink: "https://github.com/charlotteswebdev/PawsitiveAdoptions"
            },
            {
                title: 'Card 5',
                text: 'DuoDistance',
                image: 'media/DuoDistance.mp4',
                thumbnail: "media/love.jpg",
                description: "Python console application tailored for long-distance couples to stay connected. Users input their partner's name and city, and the application utilises timezone conversion libraries and a weather API to provide real-time weather updates and local time information at their partner's location. Users can create a countdown for upcoming trips to see their partner and the application provides transportation and accommodation links, streamlining travel planning and logistics. Furthermore, users have the option to write heartfelt love letters using prompts generated by the application. This comprehensive tool aims to foster connection between long-distance couples, enhancing their relationship despite physical distance.",
                codeLink: "https://github.com/charlotteswebdev/DuoDistance"
            },
            {
                title: 'Card 6',
                text: 'SumUp',
                image: '/media/SumCalculator.mp4',
                thumbnail: "media/sumupcalc.png",
                description: "Retro-style addition calculator using JavaScript. This calculator application prioritises user-friendly input validation and incorporates satisfying calculator click sounds for an immersive and enjoyable user experience.",
                codeLink: "https://github.com/charlotteswebdev/SumUp",
                demoLink: "https://sum-up-calculator.netlify.app/"
            },
        ];

        return ( <div className="container">
                <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
                    {cardData.map((card, i) => (
                        <div className="col-12 col-sm-6 col-md-4" key={i}>
                            <video className="bd-placeholder-img card-img-top" width="100%" height="225" controls poster={card.thumbnail}>
                                <source src={card.image} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                            <div className="card-body">
                                <p className="card-text">{card.text}</p>
                                <p className="card-description">
                                    {this.state.expandedCard === i ? card.description : card.description?.substring(0, 100)}
                                </p>
                                <div className="d-flex justify-content-between align-items-center">
                                    <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => this.toggleDescription(i)}>
                                        {this.state.expandedCard === i ? 'See less' : 'Read more'}
                                    </button>
                                    {this.state.expandedCard === i && card.description.length > 40}
                                </div>
                                <div className="button-container" style={{textAlign: 'left'}}>
                                <div className="btn-group">
                                    <button type="button" className="btn btn-sm btn-outline-secondary me-2" onClick={() => window.open(card.codeLink, '_blank')}>
                                        See the code <FontAwesomeIcon icon={faGithub} />
                                    </button>
                                    {card.demoLink && (
                                        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => window.open(card.demoLink, '_blank')}>
                                            Demo the Project
                                        </button>
                                    )}
                                </div>
                            </div>
                            </div>
                        </div>
                    ))}
                    </div>
                </div>
        );
    }
}

export default Projects;